import { Component, OnDestroy, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Subscription } from 'rxjs';
import { filter } from 'rxjs/operators';
import { AuthService, CustomerService } from '@core';

@Component({
    selector: 'app-order-login',
    templateUrl: './order-login.component.html',
    styleUrls: ['./order-login.component.scss'],
    standalone: false,
})
export class OrderLoginComponent implements OnInit, OnDestroy {
    public isLoggedIn = false;
    public customerName: string;
    public form: FormGroup;

    private subs = new Subscription();

    // #region Errormessages
    protected passwordErrorMessages = 'Bitte gib ein Passwort an.';
    protected mailErrorMessages = {
        required: 'Bitte gib eine E-Mail-Adresse an.',
        email: 'Bitte gib eine gültige E-Mail-Adresse an.',
    };
    // #endregion

    public constructor(
        private authService: AuthService,
        private formBuilder: FormBuilder,
        private customerService: CustomerService,
    ) {
        this.subs.add(this.subscribeToAuthStatus());
        this.subs.add(this.subscribeToCustomer());
        this.initForm();
    }

    public ngOnInit(): void {}

    public ngOnDestroy(): void {
        this.subs.unsubscribe();
    }

    public login(): void {
        this.authService.login(this.form.get('email').value, this.form.get('password').value).subscribe();
    }

    public logout(): void {
        this.authService.logout();
    }

    private initForm(): void {
        this.form = this.formBuilder.group({
            email: ['', [Validators.required, Validators.email]],
            password: ['', Validators.required],
        });
    }

    private subscribeToAuthStatus(): Subscription {
        return this.authService.isLoggedIn$.pipe().subscribe((isLoggedIn) => {
            this.isLoggedIn = isLoggedIn;
        });
    }

    private subscribeToCustomer(): Subscription {
        return this.customerService.customer$.pipe(filter((customer) => customer !== null)).subscribe((customer) => {
            this.customerName = customer.fullName;
        });
    }
}
